import React from "react";
import { Grid, useTheme } from "@mui/material";
import { useStore } from "utils/useStore";
import { observer } from "mobx-react";
import AgentStore from "../Stores/AgentStore";
import { sxClsx } from "utils/styleClsx";
import { useOpenCloseFullscreenAgent } from "../AgentUtils";
import { ChevronLeftRounded, ChevronRightRounded } from "@mui/icons-material";

export const FullscreenChevron = observer(() => {
    const agentStore = useStore(AgentStore);
    const theme = useTheme();

    const { openFullscreenAgent, closeFullscreenAgent } =
        useOpenCloseFullscreenAgent();

    return (
        <Grid
            id={
                !agentStore.fullscreen
                    ? "kbo-full-screen"
                    : "kbo-minimize-from-full-screen"
            }
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (agentStore.fullscreen) {
                    closeFullscreenAgent();
                } else {
                    openFullscreenAgent();
                }
            }}
            sx={sxClsx(
                {
                    display: "none",
                    pointerEvents: "auto",
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    backgroundColor: theme.palette.white.main,
                    paddingY: "8px",
                    width: "auto",
                    height: "auto",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: theme.zIndex.drawer + 1,
                    cursor: "pointer",
                    "&:hover": {
                        opacity: 0.5,
                    },
                },
                agentStore.fullscreen && {
                    display: "flex",

                    left: 0,
                    boxShadow:
                        "0 10px 15px 0 rgba(0, 0, 0, 0.10), 0 4px 6px 0 rgba(0, 0, 0, 0.05)",
                    borderRadius: "0px 2px 2px 0px",
                },
                !agentStore.fullscreen &&
                    agentStore.isDrawerOpen && {
                        display: "flex",

                        right: "max(20dvw, 372px)",
                        borderRadius: "2px",
                    },
            )}
        >
            {agentStore.fullscreen ? (
                <ChevronRightRounded sx={{ height: "20px", width: "20px" }} />
            ) : (
                <ChevronLeftRounded sx={{ height: "20px", width: "20px" }} />
            )}
        </Grid>
    );
});
